const GE = {
  ibanLength: 22,
};
export { GE };
